import React from "react";
import { LinkProps } from "next/dist/client/link";
import NextLink from "next/link";
import styles from "./ButtonLink.module.scss";

interface ButtonLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>, LinkProps {
  color?: "primarybaby" | "secondarybaby" | "tertiarybaby";
  size?: "xl" | "lg" | "md" | "sm" | "xs";
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ href, color, children, className, size, ...props }) => {
  const classes = `${className ? className : ""} ${color ? styles[color] : ""} ${size ? styles[size] : ""}`;
  const link = typeof href === "string" ? href : "#";

  return (
    <NextLink href={link} className={classes} {...props} prefetch={false}>
      {children}
    </NextLink>
  );
};

export default ButtonLink;
